import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NRTFormInput from "./FormInput"
import _ from 'lodash'

class NRTFormStateManager extends Component {

    /* state como variavel da classe, previne render desnecessario */
    stateBuffer = {
        valid: true,
        dirty: false,
        values: {},
        fieldsWithError: {},
    }

    inputRefs = []


    validate = async (callback) => {
        const validateResult = await Promise.all(this.inputRefs.map(input => input.current.validate()))

        this.stateBuffer.valid = !validateResult.some(result => result === false)

        if (callback)
            callback(this.stateBuffer)
    }


    reset = () => {
        this.setState({
                valid: true,
                dirty: false,
                fieldsWithError: {}

            },
            () => this.inputRefs.forEach(input => input.current.reset())
        )
    }

    onInputRemoved = (name) => {
        delete this.stateBuffer.fieldsWithError[name]
        delete this.stateBuffer.values[name]
        this.stateBuffer.valid = Object.keys(this.stateBuffer.fieldsWithError).length === 0
        this.notifyStateChanged()
    }


    setValues(changes) {
        Object.keys(changes)
            .forEach(key => {
                const inputs = this.inputRefs.filter(ref => ref.current.props.name === key)

                if (inputs[0])
                    inputs[0].current.handleChange(changes[key])
            })
    }


    onInputChange = (name) => (value, dirty = false, valid = true) => {
        _.set(this.stateBuffer.values, name, value)
        this.stateBuffer.dirty = this.stateBuffer.dirty || dirty

        if (valid)
            delete  this.stateBuffer.fieldsWithError[name]
        else
            this.stateBuffer.fieldsWithError[name] = true

        this.stateBuffer.valid = Object.keys(this.stateBuffer.fieldsWithError).length === 0
        this.notifyStateChanged()
    }


    _notifyStateChanged = () => {
        if (this.props.debug)
            this.printDebugInfo()

        if (this.props.onStateChange)
            this.props.onStateChange(this.stateBuffer)

    }

    notifyStateChanged = _.debounce(this._notifyStateChanged, 100)


    printDebugInfo = _.debounce(() => {

        const {
            dirty,
            valid,
            values

        } = this.stateBuffer

        console.log(dirty, 'Dirty')
        console.log(valid, 'Valid')
        console.log(JSON.stringify(values, null, 2))

    }, 500)


    addStateManagerPropsToInputsInChildren = (children) => {

        return React.Children.map(children, child => {

            if (!child)
                return null

            if (child.type === NRTFormInput) {
                const ref = React.createRef()
                this.inputRefs.push(ref)
                return React.cloneElement(child, {
                    notifyStateManager: this.onInputChange(child.props.name),
                    value: _.get(this.stateBuffer.values, child.props.name) || child.props.value,
                    ref
                })
            }

            if (child.props && child.props.children) {
                return React.cloneElement(child, {
                    children: this.addStateManagerPropsToInputsInChildren(child.props.children)
                })
            }

            return child
        })
    }


    render() {
        this.inputRefs = []
        return this.addStateManagerPropsToInputsInChildren(this.props.children)
    }
}


NRTFormStateManager.propTypes = {
    onStateChange: PropTypes.func.isRequired,
    debug: PropTypes.bool,
}

NRTFormStateManager.defaultProps = {}

export default NRTFormStateManager



// WEBPACK FOOTER //
// ./src/components/_common/FormStateManager/index.js